import React from 'react';
import PageTitle from '../PageTitle';
import { doRequest } from '../../helper';
import { constants } from '../../Bootstrap';

import $ from 'jquery';

export default class ManagePledge extends React.Component {
    constructor( props ) {
        super( props );

        this.state = {
            items: {},
            response: null,
            limit: 50,
            page: 1,
            currentPage: 1
        }
        this.update = this.update.bind( this );
        this.getPosts = this.getPosts.bind( this );
        this.batchUpdate = this.batchUpdate.bind( this );
        this.selectToggle = this.selectToggle.bind( this );
        this.setCurrentPage = this.setCurrentPage.bind( this );
    }
    componentDidMount() {
        var status = this.props.match.params.status;
        if ( !status ) {
            status = "enabled";
        }
        this.getPosts( status );
    }
    componentWillReceiveProps( nextProps ) {
        var status = nextProps.match.params.status;
        if ( !status ) {
            status = "enabled";
        }
        this.getPosts( status );
    }
    batchUpdate( status ) {
        var ids = [];
        var createds = [];
        $( ".multi_select:checked" ).each( function() {
            ids.push( $( this ).attr( 'data-id' ) );
            createds.push( $( this ).attr( 'data-created' ) );
        } )
        var id = ids.join( ',' );
        var created = createds.join( ',' );

        if ( id == "" ) {
            alert( "No post selected" );
        } else {
            this.update( id, created, status );
        }

    }
    update( id, created, status, otherFlag, otherFlagValue ) {
        id = "" + id;
        $( ".loader" ).show();
        if ( otherFlagValue ) {
            otherFlagValue = 1;
        } else {
            otherFlagValue = 0;
        }

        var request = doRequest( 'cms-operations', {
            'action': 'update-pledge',
            'module': 'bday',
            'model': 'pledge',
            'data': {
                'id': id,
                'status': status,
                'created': created,
                'otherFlag': otherFlag,
                'otherFlagValue': otherFlagValue
            }
        }, true );

        request.addEventListener( "load", function() {
            var response = this.responseText;
            $( ".loader" ).hide();
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    var ids = id.split( "," );
                    if ( !otherFlag ) {

                        ids.map( function( id_value ) {
                            $( "#post_" + id_value ).hide();
                        } )
                    }

                }
            } catch ( ex ) {

            }

        } );
    }
    setCategory( e ) {
        var id = $( e.target ).attr( "data-id" );
        var created = $( e.target ).attr( "data-created" );
        var value = $( e.target ).val();
        if ( value == "" ) {
            return false;
        }
        var request = doRequest( 'cms-operations', {
            'action': 'update-pledge',
            'module': 'bday',
            'model': 'pledge',
            'data': {
                'id': id,
                'status': "enabled",
                'created': created,
                'otherFlag': "type",
                'otherFlagValue': value
            }
        }, true );
        $( ".loader" ).show();
        request.addEventListener( "load", function() {
            var response = this.responseText;
            $( ".loader" ).hide();
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    var ids = id.split( "," );
                    alert( "Updated" );

                }
            } catch ( ex ) {

            }

        } );
    }

    setLanguage( e ) {
        var id = $( e.target ).attr( "data-id" );
        var created = $( e.target ).attr( "data-created" );
        var value = $( e.target ).val();
        if ( value == "" ) {
            return false;
        }
        var request = doRequest( 'cms-operations', {
            'action': 'update-infographic',
            'module': 'Sampark',
            'model': 'Infographic',
            'data': {
                'id': id,
                'status': "enabled",
                'created': created,
                'otherFlag': "locale",
                'otherFlagValue': value
            }
        }, true );
        $( ".loader" ).show();
        request.addEventListener( "load", function() {
            var response = this.responseText;
            $( ".loader" ).hide();
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    var ids = id.split( "," );
                    alert( "Updated" );

                }
            } catch ( ex ) {

            }

        } );
    }

    selectToggle() {
        if ( $( ".allChecked" ).length > 0 ) {

            $( ".multi_select" ).prop( "checked", false );
            $( ".multi_select" ).removeClass( "allChecked" );

        } else {


            $( ".multi_select" ).prop( "checked", true );
            $( ".multi_select" ).addClass( "allChecked" );
        }

    }
    getPosts( status, lastkey ) {

        var ref = this;
        var items = this.state.items;
        var page = this.state.page;
        var payload = {
            'action': 'list-pledge',
            'module': 'bday',
            'model': 'pledge',
            'data': {
                'direction': 'desc',
                'status': status,
                'limit': ref.state.limit,
                "ExclusiveStartKey":""
            }
        }
        if ( lastkey ) {
            payload['data']['lastkey'] = lastkey;
        }
        var request = doRequest( 'cms-operations', payload, true )

        request.addEventListener( "load", function() {
            var response = this.responseText;
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    items[page++] = response.items;
                    ref.setState( { "page": page, "response": response, "items": items, "lastIndex": response.lastEvaluatedKey } );
                    if ( response.lastEvaluatedKey.id ) {
                        console.log( 'called next' );
                        ref.getPosts( status, response.lastEvaluatedKey )
                    }
                }
            } catch ( ex ) {

            }

        } );
    }
    setCurrentPage() {
        this.setState( { currentPage: this.currentPage.value } );
    }
    render() {
        var response = this.state.response;
        var items = this.state.items;
        var pages = [];
        var totaluser;
        if (response) {
            totaluser = response.countdata
        }
        var lang=constants.Language;
        console.log(lang)

        for ( var i = 1; i < this.state.page; i++ ) {
            pages.push( <option>{i}</option> )
        }
        return (
            
            <div>
           <PageTitle title="NM Birthday Module" bread="NM Birthday / Manage Pledge" />
                <div className="wrapper wrapper-content">
                    <div className="wrapper wrapper-content">

                        <a className="btn btn-warning btn-xs" onClick={() => { this.batchUpdate( 'disable' ) }} type="button"><i className="fa fa-times"></i>&nbsp;Delete Selected</a>
                        &nbsp;&nbsp;<a href="javascript:void(0);" onClick={this.selectToggle}><i className="fa fa-check"></i>&nbsp;Select All Toggle</a>
                        &nbsp;&nbsp;&nbsp;Page : <select onChange={this.setCurrentPage} ref={( currentPage ) => { this.currentPage = currentPage }}>{pages}</select>
                        <div className="form-group col-sm-4">
                                <label htmlFor="">Total  : </label>
                                <span>{
                                    totaluser ? totaluser.Count : ''}</span>
                            </div>
                        <br /><br />
                        <div className="row">
                            <div className="col-lg-12">



                                {items[this.state.currentPage] ? items[this.state.currentPage].map(( value, index ) => {
                                    console.log(value)
                                    if ( value.image_path ) {
                                        var url = value.image_path;
                                        var image = value.image_path;
                                    } else if ( value.video_path ) {
                                        var url = value.video_path;
                                        var image = value.thumbnail_url;
                                    }
                                    return ( <div class="file-box" key={value.id} id={"post_" + value.id}>
                                        <div class="file">
                                            <a href="javascript:void(0)" target="_blank">
                                                <span class="corner"></span>

                                                <div class="image" style={{ "height": "auto" }}>
                                                    <img alt="image" class="img-responsive" src={image} />
                                                    <div className="image_caption">
                                                        <a href="javascript:void(0);" className="btn btn-warning btn-circle"
                                                            onClick={() => { this.update( value.id, value.created, 'disable' ) }} type="button">
                                                            <i className="fa fa-times"></i>
                                                        </a>
                                                    </div>
                                                    <a href="javascript:void(0);" style={{ "position": "absolute", "top": "10px", "left": "10px" }} className="btn btn-info btn-circle " type="button">
                                                        <input data-created={value.created} data-id={value.id} type="checkbox" className="multi_select" style={{ "margin": "2px" }} />
                                                    </a>
                                                </div>
                                                <div class="file-name">
                                                    {value.title}
                                                    <br />
                                                    <small>{value.created}</small>
                                                    <br />
                                                    <select defaultValue={value.type} data-created={value.created} data-id={value.id} className={"category_select"} onChange={this.setCategory}>
                                                        <option value="">--Category--</option>
                                                        {constants.type.map(( type ) => {
                                                            return ( <option value={type}>{type}</option> )
                                                        } )}
                                                    </select>

                                                    <select defaultValue={value.language} data-created={value.created} data-id={value.id} className={"language_select"} onChange={this.setLanguage}>
                                                        <option value="">--Language--</option>
                                                        {Object.keys(lang).map(function (key, index) {                                                       
                                                         return  <option value={key}>{lang[key]}</option> 
                                                     
                                                    }) }
                                                    </select>
                                                </div>
                                            </a>

                                        </div>
                                    </div> )

                                } ) : ""}

                                

                            </div>
                        </div>

                    </div>
                </div>
            </div> );
    }
}


// WEBPACK FOOTER //
// ./src/Components/NM_Birthday_Module_2018/ManagePledge.jsx